import React from 'react';
import { Stack } from '@mui/material';
import WholeMeStoryScrollItem from './WholeMeStoryScrollItem';

const StoryHorizontalScrollBar = ({
  items, editable, openGenericModal, onClickCallBack, errorCallBack, onDelete,
}) => (
  <Stack direction="row" spacing={3}>
    {items?.map((item) => (
      <WholeMeStoryScrollItem
        key={item?.id || item?.title}
        item={item}
        showUploadButton={item?.showUploadButton}
        onClickCallBack={onClickCallBack}
        errorCallBack={errorCallBack}
        editable={editable}
        openGenericModal={openGenericModal}
        onDelete={onDelete}
      />
    ))}
  </Stack>
);

export default StoryHorizontalScrollBar;
